module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SA-51499fc33bd23ea45b80cfaee1908b8f.png";